import { Button, ButtonProps } from '../button/button';

export const EmptyStatePrimaryAction = function EmptyStatePrimaryAction({
  ref,
  ...props
}: ButtonProps) {
  return <Button ref={ref} variant="primary" size="small" {...props} />;
};
